<div id="manageSeatsList">
    <app-header title=""></app-header>
    <div class="paybee-modal-header paybee-modal-header--regular" style="border:none;">
        <div class="px-3 pt-5 mb-4">
            <div class="paybee-modal-header__regular">
                <div class="mb-4">
                    <a style="color: RGB(0, 118, 255);cursor:pointer;" [routerLink]="['/manage/tickets-and-guests/campaign', selectedCampaignId]" fragment="guestTableTab">← Back to Tables</a>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12">
                    <div class="ticket-summary__holder headline-5 mb-2" id="manageTableName">Table Name</div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body" id="manageSeatsListContent">
        <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular-important py-0 mx-n3 mt-n3" style="padding: 0px calc(19.2px + 16px) !important;" role="tablist">
            <li class="nav-item">
                <a class="nav-link active px-0 mr-4" id="manageSeatsList" data-toggle="tab" href="#manageSeatsListTab" role="tab" aria-controls="manageSeatsListTab"
                   aria-selected="true">Seats</a>
            </li>
        </ul>
        <div class="tab-content pt-5">
            <div class="row">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <div class="ticket-summary__holder headline-5">Seats</div>
                    <button class="btn btn--paybee btn-sm modal-confirm-button" (click)="openSeatsModal()">+ Add Seat...</button>
                </div>
            </div>
            <div class="tab-pane fade show active" id="manageSeatsListTab" role="tabpanel" aria-labelledby="manageSeatsListTab">
                <div id="seats-section" class="py-4">
                    <div id="seat-list" class="d-none">
                        <div id="select-seats-section" class="d-none align-items-center justify-content-end">
                            <button id="addSeatsButton" class="btn btn--paybee btn--green button" style="min-width: 125px;">Add Seats...</button>
                        </div>
                        <div class="table--paybee">
                            <table id ="seatsList" class="table" cellspacing="0" style="width: 100%;">
                                <thead class="thead-light">
                                    <tr>
                                        <th>#</th>
                                        <th class="text-nowrap">Name</th>
                                        <th class="text-nowrap">Assigned</th>
                                        <th class="text-nowrap">Assigned Guest Name</th>
                                        <th class="text-nowrap">Assigned Guest Email</th>
                                        <th style="max-width: 150px;" class="no-export"></th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                    <div id="empty-seat-list" class="d-none mt-3">
                        <div class="d-flex flex-column align-items-center my-5">
                            <img src="img/svg/chair-solid.svg" height="40" width="40" class="mb-3">
                            <div class="headline-5 mb-2">Seats</div>
                            <div class="body-2 mb-4 d-flex flex-column align-items-center">
                                <div class="mb-1">You have no seats yet.</div>
                                <div class="mb-1">Use the button below to <span class="green-text">Add Seats</span> to this table.</div>
                            </div>
                            <button id="addSeatsButton2" class="btn btn--paybee btn--green button" style="min-width: 125px;">Add Seats...</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>